import { LitElement, html } from 'lit';
import * as alertApi from './alert-api';
import alertEvents from './alert-events';

import dispatchCustomEvent from '../../utils/dispatch-custom-event';
import translate from '../../utils/webcomponents/translate';

const succesTemplate = () => {
	const labelDeleted = translate('alerts', 'deleted', 'The alert is deleted');
	const labelClose = translate('alerts', 'close', 'Close');

	return html`
		<x-message
			modifier="positive"
			icon="checkmark"
			message="${labelDeleted}"
		></x-message>

		<div class="form__footer form__footer--centered">
			<button
				type="button"
				class="button js-close"
			>
				${labelClose}
			</button>
		</div>
	`;
};

const bodyTemplate = () => {
	const labelAreYouSire = translate('alerts', 'deleteConfirm', 'Do you know for sure?');
	const labeLCancel = translate('alerts', 'cancel', 'Cancel');
	const labeLConfirm = translate('alerts', 'confirm', 'Confirm');

	return html`
		<div class="trailer text-center">${labelAreYouSire}</div>

		<div class="form__footer form__footer--centered">
			<button class="button js-yes">${labeLConfirm}</button>
			<button class="button button--ghost js-close">${labeLCancel}</button>
		</div>
	`;
};

class AlertRemoveForm extends LitElement {
	static get properties() {
		return {
			isError: { type: Boolean },
			isSuccess: { type: Boolean },
			isLoading: { type: Boolean },

			options: {
				type: Object,
			},
		};
	}

	constructor() {
		super();

		this.isError = false;
		this.isSuccess = false;
		this.isLoading = false;

		this.onClick = this.onClick.bind(this);
	}

	async firstUpdated() {
		super.firstUpdated();

		this.addEventListener('click', this.onClick);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.onClick);

		super.disconnectedCallback();
	}

	updated() {
		dispatchCustomEvent(this, 'updated');
	}

	render() {
		return html`
			<x-loader .isLoading="${this.isLoading}"></x-loader>

			${this.isError
				? html`<x-message
						modifier="error"
						icon="warning"
						message="${translate('alerts', 'somethingWentWrong', 'Something went wrong')}"
					></x-message>`
				: ''}
			${this.isSuccess ? succesTemplate() : bodyTemplate()}
		`;
	}

	onClick(e) {
		const isConfirmButton = e.target.classList && e.target.classList.contains('js-yes');

		if (isConfirmButton) {
			this.removeItem();
		}
	}

	onSuccess() {
		this.isSuccess = true;

		dispatchCustomEvent(document.body, alertEvents.REMOVE_SUCCESS, this.options);
	}

	async removeItem() {
		this.isLoading = true;
		this.isError = false;

		const { alertConditionId } = this.options;

		try {
			await alertApi.remove(alertConditionId);
			this.onSuccess();
		} catch (e) {
			this.isError = true;
		} finally {
			this.isLoading = false;
		}
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-alert-remove-form', AlertRemoveForm);

export default AlertRemoveForm;

